module.exports = "/packs/shares-4931237-cdf984500b6b301a685cb853f00069a3.png";